<template>
  <div 
    :class="$options.name"
    v-if="!adaptive.isDesktop"
  >
    <div
      v-if="showBack"
      class="icon"
      @click="back"
    >
      <f-sprite-icon :icon-link="$options.icons.IconBack.id" />
    </div>
    <div class="title">
      {{ title }}
    </div>
    <div
      class="icon"
      @click.stop="$f.hideNav()"
    >
      <f-sprite-icon :icon-link="$options.icons.IconClose.id" />
    </div>
  </div>
</template>


<script>
import IconClose from '../../assets/icons/close.svg';
import IconBack from '../../assets/icons/back.svg';

export default {
  name: 'mobile-menu-header',

  inject: ['adaptive'],

  icons: {
    IconClose,
    IconBack,
  },

  props: {
    showBack: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => '',
    },
  },

  methods: {
    back(e) {
      // Событие обязательно
      this.$emit('back', e);
    },
  },
}

</script>

<style lang="scss">
.mobile-menu-header {
  display: flex;
  padding: 12px $containerGapMobile;
  line-height: 24px;
  .title {
    flex: 1;
    padding: 0 8px;
    overflow: hidden;
    font-size: 14px;
    white-space: nowrap;
    text-align: center;
    text-overflow: ellipsis;
  }
  .icon {
    width: 24px;
    height: 24px;
    color: $gray_lu;
  }
}
</style>